export default __webpack_public_path__ + "static/media/trash-icon-dark.56528f9b.svg";